import React from "react";
import { Row, Col } from "react-bootstrap";
import CheckCircleOutlineIcon  from "@mui/icons-material/CheckCircleOutline";
import AccessTimeIcon           from "@mui/icons-material/AccessTime";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

// Same SP-safe parser used in Charts/page.js
const sp = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  const n = Number(val);
  return isNaN(n) ? 0 : n;
};

const normalizeStatus = (status) => {
  if (!status) return "TODO";
  const s = status.trim().toLowerCase().replace(/\s+/g, "");
  if (s === "completed")  return "COMPLETED";
  if (s === "inprogress") return "INPROGRESS";
  if (s === "intesting")  return "INTESTING";
  if (s === "todo")       return "TODO";
  return "TODO";
};

const StatusCard = ({ icon, label, pct, count, total, borderColor }) => (
  <div style={{
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    borderTop: `3px solid ${borderColor}`,
    padding: "18px 20px",
    boxShadow: "0 1px 4px rgba(0,0,0,.06)",
    height: "100%",
  }}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
      <span style={{ fontSize:10, fontWeight:700, color:"#9ca3af", letterSpacing:".7px", textTransform:"uppercase" }}>
        {label}
      </span>
      {icon}
    </div>
    <div style={{ fontSize:34, fontWeight:800, color:"#111827", lineHeight:1 }}>{pct}%</div>
  <div style={{ fontSize:12, color:"#6b7280", marginTop:5 }}>
      {count} of {total} SP
    </div>
  </div>
);

const StatusCards = ({ stories }) => {
  // Story-point weighted totals (Dev SP + Tester SP per story) — same
  // calculation used in Charts/page.js, instead of a raw story count.
  const storySP = (s) => sp(s.storyPoints) + sp(s.testStoryPoints);
  const norm    = (s) => normalizeStatus(s.status);

  const total = stories.reduce((sum, s) => sum + storySP(s), 0);

  const completed = stories
    .filter((s) => norm(s) === "COMPLETED")
    .reduce((sum, s) => sum + storySP(s), 0);

  const inProgress = stories
    .filter((s) => norm(s) === "INPROGRESS" || norm(s) === "INTESTING")
    .reduce((sum, s) => sum + storySP(s), 0);

  const todo = stories
    .filter((s) => norm(s) === "TODO")
    .reduce((sum, s) => sum + storySP(s), 0);


  // Largest-remainder rounding — guarantees cPct + iPct + tPct always sums to
// exactly 100 (independent Math.round on each value can overshoot/undershoot).
let cPct = 0, iPct = 0, tPct = 0;

if (total) {
  const raw = [
    { key: "c", value: (completed  / total) * 100 },
    { key: "i", value: (inProgress / total) * 100 },
    { key: "t", value: (todo       / total) * 100 },
  ];

  const floored = raw.map((r) => ({ key: r.key, floor: Math.floor(r.value), remainder: r.value - Math.floor(r.value) }));
  let allocated = floored.reduce((sum, r) => sum + r.floor, 0);
  let remaining = 100 - allocated;

  // Give the leftover 1% (or 2%) to whichever entries have the largest remainders
  floored
    .sort((a, b) => b.remainder - a.remainder)
    .forEach((r) => {
      if (remaining > 0) { r.floor += 1; remaining -= 1; }
    });

  const result = {};
  floored.forEach((r) => { result[r.key] = r.floor; });
  cPct = result.c;
  iPct = result.i;
  tPct = result.t;
}

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} sm={6} md={4}>
        <StatusCard
          icon={<CheckCircleOutlineIcon sx={{ fontSize:20, color:"#16a34a" }} />}
          label="Completed"   pct={cPct} count={completed}  total={total} borderColor="#16a34a"
        />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <StatusCard
          icon={<AccessTimeIcon sx={{ fontSize:20, color:"#2563eb" }} />}
          label="In Progress" pct={iPct} count={inProgress} total={total} borderColor="#2563eb"
        />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <StatusCard
          icon={<RadioButtonUncheckedIcon sx={{ fontSize:20, color:"#f59e0b" }} />}
          label="To Do"       pct={tPct} count={todo}       total={total} borderColor="#f59e0b"
        />
      </Col>
    </Row>
  );
};

export default StatusCards;